/**
 * Get full image URL based on environment variable VUE_APP_IMAGE_BASE_URL
 * @param {string} path - Relative image path, e.g. 'product/supermarket-gondola-1.jpg'
 *                         or absolute path from upload, e.g. '/images/home/xxx.png'
 * @returns {string} Full image URL
 */
export const getImageUrl = (path) => {
  const base = process.env.VUE_APP_IMAGE_BASE_URL || '/images';
  const cleanPath = path.replace(/^\/+/, '');
  const encodedPath = encodeURI(cleanPath);

  // 路径已经以 images/ 开头时，base 不再追加 /images，避免出现 /images/images/...
  if (cleanPath.startsWith('images/')) {
    const baseWithoutImages = base.replace(/\/images\/?$/, '');
    return `${baseWithoutImages}/${encodedPath}`;
  }

  return `${base}/${encodedPath}`;
};
